<template>
  <a-collapse
    expand-icon-position="right"
    accordion>
    <a-collapse-panel
      :header="mainHeader">
      <div :key="`${_uid}-${mainHeader}-nested`">
        <a-list
          :data-source="source">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
          >
            <verification-document
              :document="item"
              :on-select-image-url="selectPhotoUrl"
              hide-review-result
            />
          </a-list-item>
        </a-list>
      </div>
    </a-collapse-panel>
    <photo-viewer
      v-if="selectedPhotoUrl"
      :img-url="selectedPhotoUrl"
      :is-shown.sync="isImageViewerShown"
    />
  </a-collapse>
</template>

<script>
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import AList from 'ant-design-vue/lib/list'
import VerificationDocument from '../verification-document'
import PhotoViewer from '@/vue/common/PhotoViewer'

export default {
  name: 'expandable-docs-list',
  components: {
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
    AList,
    'a-list-item': AList.Item,
    VerificationDocument,
    PhotoViewer,
  },
  props: {
    mainHeader: {
      type: String,
      required: true,
    },
    source: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selectedPhotoUrl: '',
    isImageViewerShown: false,
    isImagesDocsShown: false,
  }),
  methods: {
    selectPhotoUrl (url) {
      this.selectedPhotoUrl = url
      this.isImageViewerShown = true
    },
  },
}
</script>

<style scoped>
  @import '~ant-design-vue/lib/collapse/style/index.css';
  @import '~ant-design-vue/lib/list/style/index.css';
</style>
